<div class="pt-0 pb-5 mb-5 text-center">
    <div class="empty-state text-center cdc1">
        <img src="/assets/images/empty/empty-folder@3x.png" class="img-fluid" style="max-width: 427px;">
        <h4>{{ title }}</h4>
        <p [innerHTML]="description"></p>
        <a [href]="buttonUrl" class="btn btn-fh cd-btn px-3 btn-sm">
            {{ buttonText }}
        </a>
    </div>
</div>